import http, { Http } from '../../../../lib/http';

function requestResetPasswordCtor(http: Http) {
  return async function requestResetPassword(email: string) {
    await http.post('/auth/v1/reset-password', { email });
  };
}

export const requestResetPassword = requestResetPasswordCtor(http);
